import { DefaultResType } from "../../../types/common/response";
import { baseApi } from "../../../util/axiosConfig";

const url = "api/admin/dutyGroup/";

export async function readAllDutyGroupsApi(data: any): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "read_all_duty_groups", data);
  } catch (err: any) {
    return err?.response;
  }
}

export async function deleteDutyGroupApi(data: any): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "delete_duty_group", data);
  } catch (err: any) {
    return err?.response;
  }
}

export async function readDutyGroupByIdApi(data: any): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "read_duty_group_by_id", data);
  } catch (err: any) {
    return err?.response;
  }
}

export async function readDutyGroupMemberApi(data: any): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "read_duty_group_member", data);
  } catch (err: any) {
    return err?.response;
  }
}

export async function readGroupTypeSelectBoxApi(): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "read_group_type_select_box");
  } catch (err: any) {
    return err?.response;
  }
}

export async function readOrgSelectBoxApi(): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "read_org_select_box");
  } catch (err: any) {
    return err?.response;
  }
}
export async function readRoleSelectBoxApi(): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "read_role_select_box");
  } catch (err: any) {
    return err?.response;
  }
}

export async function createDutyGroupApi(data:any): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "create_duty_group", data);
  } catch (err: any) {
    return err?.response;
  }
}

export async function updateDutyGroupApi(data:any): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "update_duty_group", data);
  } catch (err: any) {
    return err?.response;
  }
}